export type DefeatedToolKey =
  | "erpSystem"
  | "dms"
  | "outlook"
  | "portalloesung"
  | "telefonanlage"
  | "kiAnrufbeantworter"
  | "onlineEtv"
  | "teams"
  | "uebergabeformulare";

export type DefeatedTool = {
  readonly key: DefeatedToolKey;
  /** Card top-left in stage units; card is 210×112. */
  readonly x: number;
  readonly y: number;
  readonly rot: number;
  /** €/month shown on the card and added to the counter; 0 = no price shown. */
  readonly price: number;
};

/** Stage 760×600 units. The tile grows at the center as each card is absorbed. */
export const TILE = { cx: 380, cy: 200, size: 330, from: 0.3 } as const;
export const CARD = { w: 210, h: 112 } as const;

/**
 * Order = importance = absorption = list order. The three biggest sit in the bottom row,
 * so the list (drawn there) can start once they are gone. Prices sum to 1.505 €.
 */
export const DEFEATED_TOOLS: readonly DefeatedTool[] = [
  { key: "erpSystem", x: 275, y: 456, rot: 1.5, price: 400 },
  { key: "dms", x: 0, y: 446, rot: 3, price: 300 },
  { key: "outlook", x: 550, y: 446, rot: -2.5, price: 45 },
  { key: "portalloesung", x: 550, y: 260, rot: 2.5, price: 500 },
  { key: "telefonanlage", x: 0, y: 260, rot: -2, price: 80 },
  { key: "kiAnrufbeantworter", x: 0, y: 130, rot: 2, price: 60 },
  { key: "onlineEtv", x: 550, y: 130, rot: -2.5, price: 60 },
  { key: "teams", x: 0, y: 0, rot: -3, price: 30 },
  { key: "uebergabeformulare", x: 550, y: 0, rot: 2.5, price: 30 },
];

/** Crossed-out list under the counter starts once the bottom row is gone. */
export const LIST_FROM = 3;

/** Suck-in timing in ms: one card after another, each flight ends inside the tile. */
export const ABSORB = { start: 250, step: 280, fly: 560, settle: 300 } as const;
